import { amtStr, amtStr4Dec } from 'helpers/StringNumberFunction/numFormatter';
import { dateFormat } from '../../../helpers/StringNumberFunction/formatDate';
import { ELetterServiceClient } from './service/ELetterServiceClient';
import { ELetterServicePurchase } from './service/ELetterServicePurchase';
import { ELetterServiceSubcon } from './service/ELetterServiceSubcon';
import { ELetterServiceSubcontract } from './service/ELetterServiceSubcontract';
import { ELetterServiceSupplier } from './service/ELetterServiceSupplier';
import { ELetterServiceCosting } from './service/ELetterServiceCosting';

const moduleParams = (
  accountType: string,
  docType: string,
  previewDetail,
  allpreviewDetail,
  getCompany,
  getCustomer,
  getSubcontract,
  getJournalEntry,
  page,
  pageLength,
  submittedByLedger,
  ItemIndex,
  approvalLog,
  getGlCostCentre,
) => {
  let logoUrl = getCompany[0]?.ImageUrl;

  let paramVal: any = {
    '[companyLogo]': getCompany[0]?.ImageUrl
      ? `<img style="max-height: 100px; max-width: 100px; padding:2px;"
                 src="${getCompany[0]?.ImageUrl}"
                 width="151" height="97"
                 crossorigin="anonymous">`
      : `<img style="max-height: 100px; max-width: 100px; padding:2px;"
                 src="https://static.vecteezy.com/system/resources/previews/004/141/669/non_2x/no-photo-or-blank-image-icon-loading-images-or-missing-image-mark-image-not-available-or-image-coming-soon-sign-simple-nature-silhouette-in-frame-isolated-illustration-vector.jpg"
                 width="151" height="97"
                 crossorigin="anonymous">`,
    '[companyName]': getCompany[0]?.Name!,
    '[companyRegNo]': getCompany[0]?.CompanyRegNo!,
    '[companyTinNo]': getCompany[0]?.Tin!,
    '[companyAddress]': `${getCompany[0]?.Address?.address}
  <br />
  ${
    getCompany[0]?.Address?.country == 'Singapore'
      ? `${getCompany[0]?.Address?.country} ${getCompany[0]?.Address?.postCode}`
      : `${getCompany[0]?.Address?.postCode} ${getCompany[0]?.Address?.city}, ${getCompany[0]?.Address?.state}, ${getCompany[0]?.Address?.country}`
  }`,
    '[companySstNo]': getCompany[0]?.SSTNo ? getCompany[0]?.SSTNo : '',
    '[companyGstNo]': getCompany[0]?.GSTNo ? getCompany[0]?.GSTNo : '',
    '[companyContactNo]': getCompany[0]?.ContactNo!,
    '[beneficiaryName]': getCompany[0]?.Name!,
    '[msicCode]': getCompany[0]?.assignedMsic?.[0]?.msicCode,
    '[PageNo]': previewDetail?.PageNo || previewDetail?.pageNumber || page + 1,
    '[TotalPage]':
      previewDetail?.TotalPage || previewDetail?.totalPages || pageLength,
    '[CreatedBy]': previewDetail?.auditLog?.createdName,
    '[CreatedDate]': dateFormat(previewDetail?.createdTs!),
    '[ModifiedBy]': previewDetail?.auditLog?.modName,
    '[ModifiedDate]': dateFormat(previewDetail?.modTs!),
    '[preparedBy]': submittedByLedger,
  };

  if (!!previewDetail?.ApprovalWorkflow) {
    const latestWF = previewDetail?.ApprovalWorkflow.filter(
      workflow => workflow?.WorkFlowStatus === 'COMPLETED',
    );

    latestWF[0]?.WorkflowStep?.filter(
      x => x?.ApprovalStatus === 'APPROVED',
    )?.map((el, i) => {
      const index = i + 1;
      paramVal[`[ApprovedBy${index}]`] = !!el?.Name ? el?.Name : '';
      paramVal[`[ApprovedDate${index}]`] = !!el?.ApprovalDT
        ? dateFormat(el?.ApprovalDT)
        : '';
    });
  }

  switch (accountType) {
    case 'client-account':
      ELetterServiceClient({
        docType,
        previewDetail,
        allpreviewDetail,
        paramVal,
        getCompany,
        getSubcontract,
        getCustomer,
        ItemIndex,
        approvalLog,
      });
      break;
    case 'subcontractor-account':
      ELetterServiceSubcon({
        docType,
        previewDetail,
        allpreviewDetail,
        paramVal,
        ItemIndex,
        approvalLog,
      });
      break;
    case 'supplier-account':
      ELetterServiceSupplier({
        docType,
        previewDetail,
        allpreviewDetail,
        paramVal,
        ItemIndex,
        approvalLog,
      });
      break;
    case 'project-purchase':
      ELetterServicePurchase({
        docType,
        previewDetail,
        allpreviewDetail,
        paramVal,
        ItemIndex,
        approvalLog,
      });
      break;
    case 'subcontract':
      ELetterServiceSubcontract({
        docType,
        previewDetail,
        allpreviewDetail,
        getSubcontract,
        paramVal,
        ItemIndex,
      });
      break;
    case 'project-costing':
      ELetterServiceCosting({
        docType,
        previewDetail,
        allpreviewDetail,
        getCompany,
        getJournalEntry,
        paramVal,
        getGlCostCentre,
      });
      break;
  }

  return paramVal ?? {};
};

export const groupItemDataForPreview = ({
  templateBody,
  groupKeys,
  dataItem,
}) => {
  let parser = new DOMParser();
  let doc = parser.parseFromString(templateBody, 'text/html');
  let element = doc.getElementById('ItemValue');
  const regex = /\[(.*?)\]/g;
  const matches = [];
  let match;

  while ((match = regex.exec(element.innerHTML)) !== null) {
    matches.push(match[1]);
  }

  const filteredArr = matches.filter(value => groupKeys.includes(value));

  const groupedData = dataItem.reduce((acc, item) => {
    const key = filteredArr.map(k => item[`${k}`]).join('-');

    if (!acc[key]) {
      acc[key] = { ...item };
    } else {
      acc[key].Quantity += item.Quantity;
      acc[key].BaseAmt += item.BaseAmt;
      acc[key].TaxAmt += item.TaxAmt;
      acc[key].TotalAmt += item.TotalAmt;
    }

    return acc;
  }, {});

  // Convert the result back to an array
  return Object.values(groupedData) ?? [];
};

export const groupItemData = (
  element,
  arrItem,
  Itemindex,
  threshold,
  groupKeys,
  sumValueKeys,
) => {
  const regex = /\[(.*?)\]/g;
  const matches = [];
  let match;

  while ((match = regex.exec(element.innerHTML)) !== null) {
    matches.push(match[1]);
  }

  const filteredArr = matches.filter(value => groupKeys.includes(value));

  const groupedItems: any[] = arrItem.reduce((acc, item) => {
    const key = filteredArr.map(k => item[`[${k}]`]).join('-');

    if (!acc[key]) {
      acc[key] = filteredArr.reduce(
        (obj, k) => {
          obj[`[${k}]`] = item[`[${k}]`];
          return obj;
        },
        {
          '[Quantity]': 0,
          '[TaxAmt]': 0,
          '[TotalAmt]': 0,
          '[BaseAmt]': 0,
        },
      );
    }

    sumValueKeys?.map(x => {
      acc[key][`[${x?.column}]`] += parseFloat(
        item[`[${x?.column}]`].replace(/,/g, ''),
      );
    });

    return acc;
  }, {});

  const result = Object.values(groupedItems)
    .filter((x, i) => i >= Itemindex && i + 1 <= Itemindex + 15)
    .map((item, index) => {
      let obj = {
        '[Index]': index + 1,
        '[GlobalIndex]': index + 1 + Itemindex,
        ...item,
      };
      sumValueKeys?.map(el => {
        obj[`[${el?.column}]`] =
          el?.decimal === 4
            ? amtStr4Dec(item[`[${el?.column}]`])
            : amtStr(item[`[${el?.column}]`]);
      });
      return obj;
    });
};

export const extractItemValue = (htmlString, arrItem) => {
  let parser = new DOMParser();
  let doc = parser.parseFromString(htmlString, 'text/html');
  let element = doc.getElementById('ItemValue');
  let ItemData = arrItem;

  // function to replace AllocatedItemValue data
  const replaceAllocatedItemValue = (itemhtml, obj) => {
    var keys = Object.keys(obj)
      .map(key => key.replace(/[\[\]]/g, '\\$&'))
      .join('|');
    var regex = new RegExp(keys, 'gi');

    return itemhtml.replace(regex, function(matched) {
      return obj[matched];
    });
  };

  // function to replace ItemValue data
  const replaceItemValue = (itemhtml, obj) => {
    var keys = Object.keys(obj)
      .map(key => key.replace(/[\[\]]/g, '\\$&'))
      .join('|');
    var regex = new RegExp(keys, 'gi');

    const DebitAlloc = obj?.subItem ?? [];
    let itemdoc = parser.parseFromString(itemhtml, 'text/html');
    let AllocatedItemValue = itemdoc.getElementById('AllocatedItemValue');

    // Condition if have AllocatedItemValue element
    if (AllocatedItemValue) {
      // Replace value for AllocatedItemValue if DebitAlloc have data
      if (DebitAlloc?.length > 0) {
        const alloccontainer = DebitAlloc.map(x =>
          replaceAllocatedItemValue(AllocatedItemValue.innerHTML, x),
        ).join(' ');

        AllocatedItemValue.innerHTML = alloccontainer;
      } else {
        // Remove AllocatedItemValue if DebitAlloc does not have data
        AllocatedItemValue.parentNode.removeChild(AllocatedItemValue);
      }

      return itemdoc.documentElement.outerHTML.replace(regex, function(
        matched,
      ) {
        return obj[matched];
      });
    } else {
      return itemhtml.replace(regex, function(matched) {
        return obj[matched];
      });
    }
  };

  if (element && ItemData && ItemData?.length > 0) {
    const container = ItemData.map(x =>
      replaceItemValue(element.innerHTML, x),
    ).join(' ');

    // const tempWrapper = doc.createElement('div');
    // tempWrapper.style.visibility = 'hidden';
    // tempWrapper.style.position = 'absolute';
    // tempWrapper.style.width = '210mm'; // match A4 width
    // tempWrapper.innerHTML = doc.documentElement.outerHTML;
    // document.body.appendChild(tempWrapper);

    // NOTE: PLEASE LEAVE THESE COMMENTED CODES. MIGHT NEED TO USE IT IN THE FUTURE
    // html height
    // const PAGE_HEIGHT = 1123;
    // const totalHeight = tempWrapper.scrollHeight;
    // const pageCount = Math.ceil(totalHeight / PAGE_HEIGHT);
    // const usedOnLastPage = totalHeight - (pageCount - 1) * PAGE_HEIGHT;
    // const paddingNeeded =
    // PAGE_HEIGHT - usedOnLastPage - (pageCount !== 1 ? 80 : 0);

    // Wait for DOM update (important in React)
    // requestAnimationFrame(() => {
    // const rect = element.getBoundingClientRect();
    // const viewportHeight = window.innerHeight;
    // const spaceToBottom = viewportHeight - rect.bottom - 300;
    // });

    element.innerHTML = container;

    // element.setAttribute(
    //   'style',
    //   `${element.getAttribute('style') ||
    //     ''} height: ${paddingNeeded}px`.trim(),
    // );

    // if (spaceToBottom > 0) {
    // element.setAttribute(
    //   'style',
    //   `${element.getAttribute('style') ||
    //     ''} height: ${spaceToBottom}px`.trim(),
    // );
    // }
    return doc.documentElement.outerHTML;
  }

  return htmlString;
};

export const extractAllocItemValue = (htmlString, arrItem) => {
  let parser = new DOMParser();
  let doc = parser.parseFromString(htmlString, 'text/html');
  let element = doc.getElementById('AllocItemValue');
  let ItemData = arrItem;

  const replaceItemValue = (itemhtml, obj) => {
    var keys = Object.keys(obj)
      .map(key => key.replace(/[\[\]]/g, '\\$&'))
      .join('|');
    var regex = new RegExp(keys, 'gi');

    return itemhtml.replace(regex, function(matched) {
      return obj[matched];
    });
  };

  if (element && ItemData && ItemData?.length > 0) {
    const container = ItemData.map(x =>
      replaceItemValue(element.innerHTML, x),
    ).join(' ');

    element.innerHTML = container;

    return doc.documentElement.outerHTML;
  }

  return htmlString;
};

export const extractHtmlValue = (
  htmlTemplate,
  accountType,
  docType,
  previewDetail,
  allpreviewDetail,
  getCompany,
  getCustomer,
  getSubcontract,
  getJournalEntry,
  page,
  pageLength,
  submittedByLedger,
  threshold: any,
  approvalLog,
  gLCodeCentre,
  watermarkData,
) => {
  const Itemindex = threshold * page;

  var mapObj: any = moduleParams(
    accountType,
    docType,
    previewDetail,
    allpreviewDetail,
    getCompany,
    getCustomer,
    getSubcontract,
    getJournalEntry,
    page,
    pageLength,
    submittedByLedger,
    Itemindex,
    approvalLog,
    gLCodeCentre,
  );

  var keys = Object.keys(mapObj)
    .map(key => key.replace(/[\[\]]/g, '\\$&'))
    .join('|');
  var regex = new RegExp(keys, 'gi');

  let htmlContent = htmlTemplate;
  if (!!htmlTemplate) {
    htmlContent = htmlTemplate
      .replace(regex, function(matched) {
        return mapObj[matched];
      })
      .replace(/border-top: 1px dotted #ccc;/g, '')
      .replace(/border-bottom: 1px dotted #ccc;/g, '');

    const trxnStatus = mapObj?.['[transactionStatus]'];

    if (
      (trxnStatus === 'ACTIVE' ||
        trxnStatus === 'SUBMIT' ||
        trxnStatus === 'SUBMITTED') &&
      (docType === 'direct-po' ||
        docType === 'direct-po-on-behalf-po' ||
        docType === 'purchase-order' ||
        docType === 'po-on-behalf')
    ) {
      //display DRAFT watermark for PO ACTIVE AND SUBMITTED STATUS
      const draftHtml = buildDraftOverlayHtml(
        !!watermarkData?.is_watermark ? watermarkData?.watermark_text : '',
      );
      htmlContent = injectAfterCompanyWatermark(htmlContent, draftHtml);
    } else if (trxnStatus === 'SUBMIT' || trxnStatus === 'SUBMITTED') {
      //display DRAFT watermark
      const draftHtml = buildDraftOverlayHtml(
        !!watermarkData?.is_watermark ? watermarkData?.watermark_text : '',
      );
      htmlContent = injectAfterCompanyWatermark(htmlContent, draftHtml);
    }

    // const draftHtml = buildDraftOverlayHtml(
    //   !!watermarkData?.is_watermark ? watermarkData?.watermark_text : '',
    // );
    // htmlContent = injectAfterCompanyWatermark(htmlContent, draftHtml);

    if (mapObj?.items?.length > 0) {
      htmlContent = extractItemValue(htmlContent, mapObj?.items);
    }
    if (mapObj?.allocItems?.length > 0) {
      htmlContent = extractAllocItemValue(htmlContent, mapObj?.allocItems);
    }
    htmlContent = htmlContent.replace(/\[.*?\]/g, '');
  }

  return htmlContent;
};

// function buildDraftOverlayHtml=(watermarkText) => {
//   return `
//     <!-- ========== Status Watermark ========== -->
//     <div style="
//       position: absolute;
//       top: 50%;
//       left: 50%;
//       transform: translate(-50%, -50%) rotate(-30deg);
//       font-size: 120px;
//       font-weight: bold;
//       pointer-events: none;
//       white-space: nowrap;
//       color: rgba(0, 0, 0, 0.10);
//       z-index: 1; /* after company watermark which is z-index:0 */
//     ">
//       DRAFT
//     </div>
//   `;
// })

const buildDraftOverlayHtml = watermarkText => {
  return `
    <!-- ========== Status Watermark ========== -->
    <div style="
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) rotate(-30deg);
      font-size: 120px;
      font-weight: bold;
      pointer-events: none;
      white-space: nowrap;
      color: rgba(0, 0, 0, 0.10);
      z-index: 1; /* after company watermark which is z-index:0 */
    ">
      ${watermarkText}
    </div>
  `;
};

function injectAfterCompanyWatermark(html: string, injection: string) {
  // Strategy A: insert right after the watermark comment marker (if exists)
  if (/<!--\s*==========\s*Watermark\s*==========\s*-->/i.test(html)) {
    return html.replace(
      /(<!--\s*==========\s*Watermark\s*==========\s*-->)/i,
      `$1\n${injection}`,
    );
  }

  // Strategy B: insert right after the first absolute watermark div (more robust)
  // Matches the watermark div that contains "rotate(-30deg)" and "opacity"
  const wmDivRegex = /(<div[^>]*style="[^"]*rotate\(-30deg\)[^"]*"[^>]*>[\s\S]*?<\/div>)/i;

  if (wmDivRegex.test(html)) {
    return html.replace(wmDivRegex, `$1\n${injection}`);
  }

  // Strategy C: fallback insert near the top (inside the root container)
  return injection + '\n' + html;
}
